/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import SvgIcon from "@material-ui/core/SvgIcon";


export const ReschduleIcon = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5625 9.1875H20.4375" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M20.4375 9.1875V6.9375C20.4375 6.63913 20.319 6.35298 20.108 6.142C19.897 5.93103 19.6109 5.8125 19.3125 5.8125H4.6875C4.38913 5.8125 4.10298 5.93103 3.892 6.142C3.68103 6.35298 3.5625 6.63913 3.5625 6.9375V19.3125C3.5625 19.6109 3.68103 19.897 3.892 20.108C4.10298 20.319 4.38913 20.4375 4.6875 20.4375H10.3125" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.0625 3.5625V5.8125" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.9375 3.5625V5.8125" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.9375 20.4375C18.4228 20.4375 20.4375 18.4228 20.4375 15.9375C20.4375 13.4522 18.4228 11.4375 15.9375 11.4375C13.4522 11.4375 11.4375 13.4522 11.4375 15.9375C11.4375 18.4228 13.4522 20.4375 15.9375 20.4375Z" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.9375 13.6875V15.9375H18.1875" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)

export const CalendarIcon = ({
  stroke = 'black',
  fill = 'none'
}) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M10.953 14.9043H9.33398V15.7138H10.953V14.9043Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15.8105 14.9043H14.1914V15.7138H15.8105V14.9043Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M10.953 18.9521H9.33398V19.7617H10.953V18.9521Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15.8105 18.9521H14.1914V19.7617H15.8105V18.9521Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M20.6679 14.9043H19.0488V15.7138H20.6679V14.9043Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M10.953 14.9043H9.33398V15.7138H10.953V14.9043Z" fill={stroke} />
    <path d="M15.8105 14.9043H14.1914V15.7138H15.8105V14.9043Z" fill={stroke} />
    <path d="M10.953 18.9521H9.33398V19.7617H10.953V18.9521Z" fill={stroke} />
    <path d="M15.8105 18.9521H14.1914V19.7617H15.8105V18.9521Z" fill={stroke} />
    <path d="M20.6679 14.9043H19.0488V15.7138H20.6679V14.9043Z" fill={stroke} />
    <path d="M22.2862 7.61914H7.71475C6.82058 7.61914 6.0957 8.34401 6.0957 9.23819V21.381C6.0957 22.2752 6.82058 23.0001 7.71475 23.0001H22.2862C23.1804 23.0001 23.9052 22.2752 23.9052 21.381V9.23819C23.9052 8.34401 23.1804 7.61914 22.2862 7.61914Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M10.1426 6V8.42857" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M19.8574 6V8.42857" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M6.0957 11.667H23.9052" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const ClockIcon = ({
  stroke = '#666',
  fill = 'none',
  width = "30",
  height = "30"
}) => (
  <svg width={width} height={height} viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M15.1667 24.3333C20.2293 24.3333 24.3333 20.2293 24.3333 15.1667C24.3333 10.1041 20.2293 6 15.1667 6C10.1041 6 6 10.1041 6 15.1667C6 20.2293 10.1041 24.3333 15.1667 24.3333Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15.166 10.167V15.167H20.166" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const ReportIcon = ({
  stroke = '#666',
  fill = 'none'
}) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M10.834 22.5003V11.667" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15 22.4997V15.833" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M19.166 22.5003V11.667" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M23.334 22.4997V15.833" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M6.66602 22.5V7.5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const CogIcon = ({
  stroke = '#666',
  fill = 'none'
}) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M24.1673 14.9997C24.1673 14.0788 23.4215 13.333 22.5007 13.333H21.449C21.2915 12.723 21.0515 12.148 20.739 11.618L21.4823 10.8747C22.1332 10.2238 22.1332 9.16884 21.4823 8.51801C20.8315 7.86717 19.7765 7.86717 19.1257 8.51801L18.3823 9.26134C17.8523 8.94884 17.2773 8.70884 16.6673 8.55134V7.49967C16.6673 6.57967 15.9215 5.83301 15.0007 5.83301C14.0798 5.83301 13.334 6.57884 13.334 7.49967V8.55134C12.724 8.70884 12.149 8.94884 11.619 9.26134L10.8757 8.51801C10.2248 7.86717 9.16982 7.86717 8.51898 8.51801C7.86815 9.16884 7.86815 10.2238 8.51898 10.8747L9.26232 11.618C8.94982 12.148 8.70982 12.723 8.55232 13.333H7.50065C6.58065 13.333 5.83398 14.0788 5.83398 14.9997C5.83398 15.9205 6.57982 16.6663 7.50065 16.6663H8.55232C8.70982 17.2763 8.94982 17.8513 9.26232 18.3813L8.51898 19.1247C7.86815 19.7755 7.86815 20.8305 8.51898 21.4813C9.16982 22.1322 10.2248 22.1322 10.8757 21.4813L11.619 20.738C12.1482 21.0505 12.724 21.2905 13.334 21.448V22.4997C13.334 23.4197 14.0798 24.1663 15.0007 24.1663C15.9215 24.1663 16.6673 23.4205 16.6673 22.4997V21.448C17.2773 21.2905 17.8523 21.0505 18.3823 20.738L19.1257 21.4813C19.7765 22.1322 20.8315 22.1322 21.4823 21.4813C22.1332 20.8305 22.1332 19.7755 21.4823 19.1247L20.739 18.3813C21.0515 17.8522 21.2915 17.2763 21.449 16.6663H22.5007C23.4207 16.6663 24.1673 15.9205 24.1673 14.9997Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const CloseIcon = ({
  stroke = "black",
  fill = "none",
  width = "24",
  height = "24"
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5 5.5L5.5 19.5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M19.5 19.5L5.5 5.5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const MultiUserIcon = ({
  stroke = "#999999",
  strokeWidth = "1",
  fill = "none",
  width = "48",
  height = "48"
}) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 22.5C21.4706 22.5 25.5 18.4706 25.5 13.5C25.5 8.52944 21.4706 4.5 16.5 4.5C11.5294 4.5 7.5 8.52944 7.5 13.5C7.5 18.4706 11.5294 22.5 16.5 22.5Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} />
    <path d="M37.5 19.5C40.8137 19.5 43.5 16.8137 43.5 13.5C43.5 10.1863 40.8137 7.5 37.5 7.5C34.1863 7.5 31.5 10.1863 31.5 13.5C31.5 16.8137 34.1863 19.5 37.5 19.5Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} />
    <path d="M16.5 28.5C12.5218 28.5 8.70644 30.0804 5.8934 32.8934C3.08035 35.7064 1.5 39.5218 1.5 43.5H31.5C31.5 39.5218 29.9196 35.7064 27.1066 32.8934C24.2936 30.0804 20.4782 28.5 16.5 28.5V28.5Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} />
    <path d="M32.5225 27C33.9967 26.0191 35.7287 25.4971 37.4995 25.5C39.8864 25.5 42.1756 26.4482 43.8634 28.136C45.5513 29.8239 46.4995 32.1131 46.4995 34.5V37.5H37.4995" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} />
  </svg>
);

export const LetterIcon = ({
  stroke = "#999",
  fill = "none"
}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 5L8 9L15.5 5" stroke={stroke} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 14.5H1.5C0.948 14.5 0.5 14.052 0.5 13.5V2.5C0.5 1.948 0.948 1.5 1.5 1.5H14.5C15.052 1.5 15.5 1.948 15.5 2.5V13.5C15.5 14.052 15.052 14.5 14.5 14.5Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PhoneCallIcon = ({
  stroke = "#999999",
  fill = "none"
}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M9.1782 10.529L8.1192 11.854C6.47845 10.8892 5.11098 9.52176 4.1462 7.881L5.4712 6.822C5.62644 6.69772 5.73615 6.52552 5.78318 6.3323C5.83022 6.13909 5.81194 5.93573 5.7312 5.754L4.5242 3.036C4.43768 2.84103 4.28471 2.68312 4.09258 2.59045C3.90046 2.49777 3.68166 2.47635 3.4752 2.53L1.1752 3.13C0.960135 3.18497 0.772967 3.31747 0.649665 3.50206C0.526363 3.68664 0.475625 3.91028 0.507202 4.13C0.911131 7.00121 2.23885 9.66287 4.28964 11.7126C6.34042 13.7623 9.00278 15.0886 11.8742 15.491C12.0939 15.5226 12.3176 15.4718 12.5021 15.3485C12.6867 15.2252 12.8192 15.0381 12.8742 14.823L13.4742 12.523C13.5276 12.3167 13.506 12.0981 13.4134 11.9062C13.3207 11.7143 13.163 11.5615 12.9682 11.475L10.2462 10.27C10.0646 10.1892 9.86129 10.1707 9.66808 10.2176C9.47487 10.2644 9.30262 10.3739 9.1782 10.529V10.529Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.5 4C9.42826 4 10.3185 4.36875 10.9749 5.02513C11.6313 5.6815 12 6.57174 12 7.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.5 1C9.35359 1 10.1988 1.16813 10.9874 1.49478C11.7761 1.82144 12.4926 2.30023 13.0962 2.90381C13.6998 3.50739 14.1786 4.22394 14.5052 5.01256C14.8319 5.80117 15 6.64641 15 7.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ApprovalIcon = ({
  fill = "none",
  stroke = "#333333"
}) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6667 9.5L15.3334 11.1667L19.5 7" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M14.5 23.5303C14.5 23.027 14.2792 22.5478 13.885 22.2353C13.2825 21.757 12.2375 21.167 10.75 21.167C9.2625 21.167 8.2175 21.757 7.615 22.2353C7.22083 22.5478 7 23.027 7 23.5303V24.5003H14.5V23.5303Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M10.75 18.6667C11.9006 18.6667 12.8334 17.7339 12.8334 16.5833C12.8334 15.4327 11.9006 14.5 10.75 14.5C9.59943 14.5 8.66669 15.4327 8.66669 16.5833C8.66669 17.7339 9.59943 18.6667 10.75 18.6667Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M25.3333 23.5303C25.3333 23.027 25.1125 22.5478 24.7183 22.2353C24.1158 21.757 23.0708 21.167 21.5833 21.167C20.0958 21.167 19.0508 21.757 18.4483 22.2353C18.0541 22.5478 17.8333 23.027 17.8333 23.5303V24.5003H25.3333V23.5303Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M21.5833 18.6667C22.7339 18.6667 23.6667 17.7339 23.6667 16.5833C23.6667 15.4327 22.7339 14.5 21.5833 14.5C20.4327 14.5 19.5 15.4327 19.5 16.5833C19.5 17.7339 20.4327 18.6667 21.5833 18.6667Z" stroke={stroke} strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const DeleteIcon = ({
  fill = "none",
  stroke = "#333333"
}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.41699 8.75V14.5833C5.41699 15.5042 6.16283 16.25 7.08366 16.25H13.7503C14.6712 16.25 15.417 15.5042 15.417 14.5833V8.75" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4.5835 6.25H16.2502" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.75 6.25V3.75H12.0833V6.25" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.417 9.58301V13.7497" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.917 9.58301V13.7497" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.91699 9.58301V13.7497" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)

export const DownArrowIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M11 6L6 1L1 6" stroke="#333333" stroke-miterlimit="10" strokeLinecap="square" />
    </SvgIcon>
  );
};


export const RefreshIcon = ({
  fill = "none",
  stroke = "#333333"
}) => {
  return (
    <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.4502 7.65C3.4502 4.9438 5.644 2.75 8.3502 2.75C10.1954 2.75 11.7298 3.8987 12.5502 5.55" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.55 2.75V5.55H9.75" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.2504 8.34961C13.2504 11.0558 11.0566 13.2496 8.35039 13.2496C6.50519 13.2496 4.97079 12.1009 4.15039 10.4496" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.15039 13.2502V10.4502H6.95039" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}



export const Facebook = ({
  stroke = "black"
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 12.073C24 5.446 18.627 0.072998 12 0.072998C5.373 0.072998 0 5.446 0 12.073C0 18.063 4.388 23.027 10.125 23.927V15.542H7.078V12.072H10.125V9.43C10.125 6.423 11.917 4.761 14.658 4.761C15.97 4.761 17.344 4.996 17.344 4.996V7.949H15.83C14.339 7.949 13.874 8.874 13.874 9.823V12.073H17.202L16.67 15.543H13.874V23.928C19.612 23.027 24 18.062 24 12.073Z" fill={stroke} />
    </svg>
  )
}

export const Twitter = ({
  stroke = "black"
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.953 4.57003C23.0545 4.96563 22.1026 5.22677 21.128 5.34503C22.1541 4.72828 22.9224 3.76107 23.291 2.62203C22.34 3.17703 21.286 3.58103 20.164 3.80603C19.4238 3.01446 18.4429 2.48945 17.3736 2.31253C16.3044 2.13561 15.2067 2.31668 14.2509 2.82762C13.2952 3.33856 12.5349 4.15078 12.0881 5.13815C11.6412 6.12552 11.533 7.2328 11.78 8.28803C7.69 8.09503 4.067 6.13003 1.64 3.16203C1.19879 3.91184 0.968664 4.76705 0.974 5.63703C0.974 7.34703 1.844 8.85003 3.162 9.73303C2.38086 9.70816 1.61697 9.49696 0.934 9.11703V9.17703C0.933557 10.3134 1.32627 11.415 2.04551 12.2948C2.76474 13.1746 3.76621 13.7785 4.88 14.004C4.1583 14.1974 3.40241 14.2265 2.668 14.089C2.98412 15.067 3.59766 15.922 4.42301 16.5345C5.24837 17.1471 6.24435 17.4867 7.272 17.506C5.53153 18.872 3.38248 19.6133 1.17 19.611C0.78 19.611 0.391 19.588 0 19.544C2.25571 20.9884 4.87851 21.755 7.557 21.753C16.61 21.753 21.555 14.257 21.555 7.76803C21.555 7.55803 21.555 7.34803 21.54 7.13803C22.506 6.44289 23.3392 5.57985 24 4.59003L23.953 4.57003Z" fill={stroke} />
    </svg>
  )
}

export const Earth = () => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="20" height="20" viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
        fill="#26bbed" stroke="none">
        <path d="M63 220 c-36 -21 -64 -67 -62 -102 l1 -23 6 23 c9 29 12 30 37 12 25
  -19 45 -54 45 -79 0 -11 6 -23 13 -27 6 -4 9 -4 5 1 -4 4 2 21 13 37 21 28 21
  30 3 43 -11 7 -31 16 -46 19 -27 5 -40 26 -17 26 15 0 53 33 57 48 1 6 -1 11
  -5 11 -20 -3 -34 2 -28 11 15 24 105 0 105 -27 0 -8 -5 -11 -12 -7 -7 4 -8 3
  -4 -4 4 -7 2 -12 -5 -12 -7 0 -9 -3 -6 -7 4 -3 2 -12 -4 -19 -12 -15 -4 -34
  16 -34 14 0 25 -21 25 -50 0 -21 -26 -38 -75 -52 -26 -7 -24 -7 10 -3 52 6 95
  48 101 101 6 48 -11 81 -55 111 -42 28 -76 29 -118 3z m147 -60 c13 -8 13 -10
  -2 -10 -9 0 -20 5 -23 10 -8 13 5 13 25 0z"/>
        <path d="M10 82 c0 -17 55 -72 72 -72 7 1 1 7 -14 16 -15 8 -34 27 -42 42 -9
  15 -15 21 -16 14z"/>
      </g>
    </svg>
  )
}


export const BoxUpperArrow = ({ stroke = "black" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.7219 17.7219H6.04278V6.04278H11V5H6.52941C5.68059 5 5 5.68824 5 6.52941V17.2353C5 18.0765 5.68059 18.7647 6.52941 18.7647H17.2353C18.0765 18.7647 18.7647 18.0765 18.7647 17.2353V12.7329H17.7219V17.7219ZM13.4118 5V6.04278H16.8877L8.54545 14.385L9.37968 15.2193L17.7219 6.87701V10.3529H18.7647V5H13.4118Z" fill={stroke} />
    </svg>
  )
}



export const DragIcon = ({ stroke = '#333333',
  fill = 'none' }) => (
  < svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M9.33268 13.9998C9.33268 14.7332 8.73268 15.3332 7.99935 15.3332C7.26602 15.3332 6.66602 14.7332 6.66602 13.9998C6.66602 13.2665 7.26602 12.6665 7.99935 12.6665C8.73268 12.6665 9.33268 13.2665 9.33268 13.9998ZM7.99935 8.6665C7.26602 8.6665 6.66602 9.2665 6.66602 9.99984C6.66602 10.7332 7.26602 11.3332 7.99935 11.3332C8.73268 11.3332 9.33268 10.7332 9.33268 9.99984C9.33268 9.2665 8.73268 8.6665 7.99935 8.6665ZM7.99935 4.6665C7.26602 4.6665 6.66602 5.2665 6.66602 5.99984C6.66602 6.73317 7.26602 7.33317 7.99935 7.33317C8.73268 7.33317 9.33268 6.73317 9.33268 5.99984C9.33268 5.2665 8.73268 4.6665 7.99935 4.6665ZM11.9993 7.33317C12.7327 7.33317 13.3327 6.73317 13.3327 5.99984C13.3327 5.2665 12.7327 4.6665 11.9993 4.6665C11.266 4.6665 10.666 5.2665 10.666 5.99984C10.666 6.73317 11.266 7.33317 11.9993 7.33317ZM11.9993 8.6665C11.266 8.6665 10.666 9.2665 10.666 9.99984C10.666 10.7332 11.266 11.3332 11.9993 11.3332C12.7327 11.3332 13.3327 10.7332 13.3327 9.99984C13.3327 9.2665 12.7327 8.6665 11.9993 8.6665ZM11.9993 12.6665C11.266 12.6665 10.666 13.2665 10.666 13.9998C10.666 14.7332 11.266 15.3332 11.9993 15.3332C12.7327 15.3332 13.3327 14.7332 13.3327 13.9998C13.3327 13.2665 12.7327 12.6665 11.9993 12.6665Z" fill={stroke} />
  </svg >
)

export const PreviewUrl = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7219 14.7219H4.04278V3.04278H9V2H4.52941C3.68059 2 3 2.68824 3 3.52941V14.2353C3 15.0765 3.68059 15.7647 4.52941 15.7647H15.2353C16.0765 15.7647 16.7647 15.0765 16.7647 14.2353V9.7329H15.7219V14.7219ZM11.4118 2V3.04278H14.8877L6.54545 11.385L7.37968 12.2193L15.7219 3.87701V7.35294H16.7647V2H11.4118Z" fill={stroke} />
  </svg>
)

export const SmallPreviewUrl = ({
  stroke = '#333333',
  fill = 'none' }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.88128 9.81466H2.09518V2.02856H5.39999V1.33337H2.4196C1.85372 1.33337 1.39999 1.7922 1.39999 2.35298V9.49024C1.39999 10.051 1.85372 10.5098 2.4196 10.5098H9.55686C10.1176 10.5098 10.5765 10.051 10.5765 9.49024V6.48864H9.88128V9.81466ZM7.00784 1.33337V2.02856H9.32513L3.76363 7.59006L4.31978 8.14621L9.88128 2.58471V4.902H10.5765V1.33337H7.00784Z" fill={stroke} />
  </svg>


)

export const EmbedUrl = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5 9.5H11.5V19.5H19.5V9.5Z" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.5 17.5H4.5V4.5H15.5V6.5" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)

export const TickIcon = ({
  stroke = '#66D184',
  fill = 'none'
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="2" fill="white" />
    <path d="M4.7998 13.68L9.25695 18L20.3998 7.20001" stroke="#66D184" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square" />
  </svg>

)


export const BackArrow = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 5.5H0.5" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.5 0.5L0.5 5.5L5.5 10.5" stroke={stroke} stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)


export const MandatoryIcon = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9936 6.7002L10.6703 9.67041L13.663 8.83574L13.8585 10.2043L10.9936 10.4374L12.8584 12.8888L11.5651 13.5956L10.2416 10.8735L9.03852 13.5956L7.71509 12.8888L9.53481 10.4374L6.69995 10.2043L6.91802 8.83574L9.85815 9.67041L9.53481 6.7002H10.9936Z" fill={stroke} />
  </svg>
)

export const SingleEvent = ({
  stroke = '#333333',
  fill = 'none'
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.6665 4.66675L11.3332 7.33341H9.33317C8.09549 7.33341 6.90851 7.82508 6.03334 8.70025C5.15817 9.57542 4.6665 10.7624 4.6665 12.0001C4.6665 13.2378 5.15817 14.4247 6.03334 15.2999" stroke="#999999" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.3332 19.3334L12.6665 16.6667H14.6665C15.9042 16.6667 17.0912 16.175 17.9663 15.2999C18.8415 14.4247 19.3332 13.2377 19.3332 12C19.3332 10.7624 18.8415 9.57537 17.9663 8.7002" stroke="#999999" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 20L20 4" stroke="#999999" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const RecurringEvent = ({ stroke = '#333333',
  fill = 'none' }) => {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.6665 4.66675L11.3332 7.33341H9.33317C8.09549 7.33341 6.90851 7.82508 6.03334 8.70025C5.15817 9.57542 4.6665 10.7624 4.6665 12.0001V12.0001C4.6665 13.2378 5.15817 14.4247 6.03334 15.2999C6.90851 16.1751 8.09549 16.6667 9.33317 16.6667H9.99984" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15.3332 19.3334L12.6665 16.6667H14.6665C15.9042 16.6667 17.0912 16.175 17.9663 15.2999C18.8415 14.4247 19.3332 13.2377 19.3332 12C19.3332 10.7624 18.8415 9.57538 17.9663 8.70021C17.0912 7.82504 15.9042 7.33337 14.6665 7.33337H13.9998" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

}

export const FilterIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.70352 7.2212C6.26048 6.55665 6.73687 5.6665 7.53557 5.6665H17.1319C17.9306 5.6665 18.407 6.55665 17.9639 7.2212L13.835 13.4146C13.7255 13.5788 13.6671 13.7719 13.6671 13.9693V17.9998C13.6671 18.5521 13.2193 18.9998 12.6671 18.9998H12.0004C11.4481 18.9998 11.0004 18.5521 11.0004 17.9998V13.9693C11.0004 13.7719 10.9419 13.5788 10.8324 13.4146L6.70352 7.2212Z"
        stroke="#333333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
};

export const ArtieIcon = () => (
  <svg
    width="143"
    height="140"
    viewBox="0 0 143 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M98.7578 8.48283C98.7578 0.47086 75.6754 0.242188 73.0447 0.242188C70.4143 0.242188 47.3315 0.471195 47.3315 8.48283C47.3315 9.42599 47.6545 10.2637 48.2201 11.0009C49.0233 12.0449 50.3237 12.9013 51.9175 13.597C58.7892 16.605 71.1621 16.7242 73.0447 16.7242C74.9363 16.7242 87.4056 16.6053 94.2617 13.5605C95.8176 12.8695 97.0838 12.0268 97.8699 11.0009C98.4393 10.264 98.7578 9.42632 98.7578 8.48283ZM94.1172 8.37302C94.1681 8.40951 94.2191 8.44634 94.2617 8.48283C92.5535 9.89774 85.3278 12.1453 73.0447 12.1453C60.9664 12.1453 53.7789 9.97073 51.9175 8.55147C51.8877 8.5287 51.8582 8.5056 51.8283 8.48283C51.8709 8.44634 51.9219 8.40951 51.9728 8.37302C53.9148 6.95376 61.0811 4.82036 73.0447 4.82036C85.0089 4.82036 92.1746 6.95376 94.1172 8.37302Z"
      fill="url(#paint0_linear_2705_52702)"
    />
    <path
      d="M94.308 13.5394C96.3124 12.6411 96.3695 9.59771 94.422 8.56415C94.3139 8.5069 94.2545 8.47744 94.261 8.48313C92.5528 9.89803 85.3271 12.1456 73.044 12.1456C60.9657 12.1456 53.7783 9.97102 51.9168 8.55176C51.887 8.529 51.8575 8.5059 51.8276 8.48313C51.8339 8.47744 51.7761 8.50623 51.6704 8.56215C49.7163 9.59838 49.785 12.6471 51.7978 13.5448C51.8373 13.5622 51.8767 13.5796 51.9168 13.597C58.7885 16.6049 71.1614 16.7241 73.044 16.7241C74.9356 16.7241 87.4049 16.6053 94.261 13.5605C94.2769 13.5531 94.2921 13.5464 94.308 13.5394Z"
      fill="url(#paint1_radial_2705_52702)"
    />
    <path
      d="M64.7982 139.329H56.4956C55.5517 139.329 54.7861 138.504 54.7861 137.487C54.7861 136.471 55.5517 135.646 56.4956 135.646H60.5889C56.5363 113.111 60.8857 99.9822 61.0787 99.417C61.4048 98.4625 62.3882 97.9746 63.2737 98.3259C64.1589 98.6767 64.6123 99.7334 64.2875 100.687C64.2251 100.874 59.8275 114.39 64.3544 137.101L64.7982 139.329Z"
      fill="#009BCC"
    />
    <path
      d="M89.5928 139.329H80.98L81.4244 137.101C85.9591 114.345 81.5354 100.821 81.49 100.687C81.1683 99.7328 81.6237 98.6755 82.5085 98.3266C83.3931 97.978 84.374 98.4645 84.6994 99.4177C84.8931 99.9829 89.2419 113.112 85.1892 135.647H89.5928C90.5373 135.647 91.3028 136.471 91.3028 137.488C91.3028 138.505 90.5373 139.329 89.5928 139.329Z"
      fill="#009BCC"
    />
    <path
      d="M110.94 66.1489C110.94 84.9685 107.929 101.5 93.3115 108.777C92.895 108.985 92.4689 109.187 92.0338 109.377C88.8415 110.784 85.1335 111.782 80.8319 112.301C78.5848 112.574 76.1729 112.717 73.5867 112.72H73.5C73.3477 112.72 73.1982 112.717 73.0459 112.713C72.8936 112.717 72.7447 112.72 72.5893 112.72H72.4989C69.9164 112.717 67.5048 112.574 65.2574 112.301C60.9558 111.782 57.2475 110.784 54.0549 109.377C53.6204 109.184 53.194 108.982 52.7778 108.774C38.1608 101.497 35.1484 84.9658 35.1484 66.1489C35.1484 43.7615 46.9936 28.5046 64.6047 25.2422C66.9419 24.8057 69.3783 24.583 71.9055 24.583C72.1048 24.583 72.2996 24.586 72.4986 24.586C72.6819 24.592 72.8622 24.5947 73.0456 24.6008C73.2258 24.5947 73.4061 24.592 73.5864 24.586C73.7856 24.586 73.9845 24.583 74.1831 24.583C76.7103 24.583 79.147 24.8057 81.484 25.2422C99.0953 28.5046 110.94 43.7612 110.94 66.1489Z"
      fill="url(#paint2_radial_2705_52702)"
    />
    <path
      d="M33.506 107.474C32.6914 107.319 32.0147 106.849 31.9371 106.355C29.7884 92.6621 35.5678 83.8249 35.8147 83.4551C36.123 82.9943 37.0903 82.8712 37.9744 83.1837C38.858 83.4941 39.3249 84.1194 39.0176 84.58C38.9595 84.6672 33.2365 93.449 35.314 106.687C35.4 107.235 34.7137 107.605 33.7813 107.514C33.6883 107.504 33.5957 107.491 33.506 107.474Z"
      fill="#009BCC"
    />
    <path
      d="M36.7196 107.175C36.8214 104.886 35.3127 102.756 33.3509 102.417C31.3883 102.078 29.7156 103.659 29.6139 105.948C29.5128 108.236 31.0214 110.366 32.9834 110.704C34.9456 111.044 36.6186 109.463 36.7196 107.175Z"
      fill="#009BCC"
    />
    <path
      d="M114.691 109.717C114.604 109.75 114.515 109.779 114.424 109.805C113.515 110.059 112.773 109.815 112.767 109.26C112.624 95.86 105.49 88.2175 105.418 88.1417C105.036 87.7422 105.396 87.0442 106.22 86.5834C107.047 86.1224 108.023 86.0722 108.405 86.4717C108.712 86.7919 115.913 94.4788 116.06 108.339C116.066 108.839 115.472 109.421 114.691 109.717Z"
      fill="#009BCC"
    />
    <path
      d="M111.48 110.005C111.001 107.774 112.14 105.416 114.023 104.737C115.906 104.058 117.821 105.317 118.3 107.548C118.778 109.778 117.639 112.136 115.756 112.815C113.873 113.493 111.958 112.235 111.48 110.005Z"
      fill="#009BCC"
    />
    <path
      d="M102.618 90.5709C102.618 90.5709 115.772 90.3981 121.107 87.4612C125.661 84.9535 129.281 81.7453 128.522 76.5156C128.522 76.5156 124.242 80.6107 119.633 79.7459C108.035 77.5693 101.861 85.3435 102.618 90.5709Z"
      fill="url(#paint3_radial_2705_52702)"
    />
    <path
      d="M105.601 82.2629C105.601 82.2629 120.884 82.063 127.081 78.6496C132.372 75.7358 136.578 72.0084 135.697 65.9336C135.697 65.9336 130.723 70.6912 125.369 69.6865C111.894 67.1573 104.722 76.1888 105.601 82.2629Z"
      fill="url(#paint4_radial_2705_52702)"
    />
    <path
      d="M106.479 77.3422C106.479 77.3422 125.409 75.2249 132.734 70.2342C138.987 65.9738 143.81 60.8375 142.077 53.4121C142.077 53.4121 136.412 59.9201 129.666 59.3288C112.691 57.8413 104.748 69.9175 106.479 77.3422Z"
      fill="url(#paint5_radial_2705_52702)"
    />
    <path
      d="M40.4916 88.9117C40.4916 88.9117 27.3383 88.7396 22.0029 85.802C17.449 83.2943 13.8283 80.0855 14.5867 74.8564C14.5867 74.8564 18.8681 78.9515 23.4774 78.0867C35.0755 75.9101 41.2497 83.6843 40.4916 88.9117Z"
      fill="url(#paint6_radial_2705_52702)"
    />
    <path
      d="M37.5076 80.6047C37.5076 80.6047 22.2258 80.4041 16.028 76.9914C10.7371 74.0776 6.53123 70.3502 7.41206 64.2754C7.41206 64.2754 12.3856 69.033 17.7399 68.0283C31.215 65.4991 38.3885 74.5306 37.5076 80.6047Z"
      fill="url(#paint7_radial_2705_52702)"
    />
    <path
      d="M36.6296 75.6831C36.6296 75.6831 17.7008 73.5657 10.3747 68.5751C4.12158 64.3146 -0.700892 59.1783 1.03155 51.7529C1.03155 51.7529 6.69728 58.2609 13.4427 57.6697C30.42 56.1821 38.3621 68.2583 36.6296 75.6831Z"
      fill="url(#paint8_radial_2705_52702)"
    />
    <path
      d="M99.3376 95.9031L99.3 96.0122L95.0889 96.8134C95.0699 97.8868 94.8837 104.225 93.04 109.037C92.7979 109.114 92.5527 109.188 92.3037 109.259C94.3768 104.084 94.4672 96.7676 94.4704 96.6721V96.5302L98.7629 95.7139C99.4184 93.4958 99.3311 84.5641 99.328 84.4727L99.9496 84.4707C99.9555 84.8537 100.043 93.8484 99.3376 95.9031Z"
      fill="#ABB1B8"
    />
    <path
      d="M51.618 96.6721C51.6217 96.7676 51.7115 104.082 53.7846 109.257C53.5363 109.186 53.2905 109.112 53.0483 109.035C51.2052 104.223 51.0184 97.8868 51.0001 96.8134L46.7883 96.0122L46.7514 95.9031C46.0455 93.8484 46.1328 84.8537 46.1387 84.4707L46.7603 84.4727C46.7572 84.5641 46.6699 93.4958 47.326 95.7139L51.618 96.5302V96.6721Z"
      fill="#ABB1B8"
    />
    <path
      d="M73.3545 24.5967V112.72H72.7329V24.5967C72.8355 24.5967 72.9412 24.5997 73.0437 24.6027C73.1463 24.5997 73.252 24.5967 73.3545 24.5967Z"
      fill="#ABB1B8"
    />
    <path
      d="M57.0839 89.3999H89.0042C99.9953 89.3999 109.184 80.6795 110.91 69.3449C110.737 62.9052 109.777 57.0192 108.136 51.7815C103.478 41.9977 94.0085 35.2627 83.1489 35.2627H62.9392C52.0762 35.2627 42.6049 42.0024 37.9484 51.7909C36.3095 57.0243 35.3504 62.9042 35.1772 69.3372C36.9016 80.6755 46.091 89.3999 57.0839 89.3999Z"
      fill="#ABB1B8"
    />
    <path
      d="M89.0045 86.7831H57.0842C44.8741 86.7831 34.8838 76.021 34.8838 62.868C34.8838 46.2458 47.5085 32.6455 62.9398 32.6455H83.1495C98.5805 32.6455 111.206 46.2454 111.206 62.868C111.206 76.021 101.216 86.7831 89.0045 86.7831Z"
      fill="url(#paint9_radial_2705_52702)"
    />
    <path
      d="M87.6386 84.4654H58.4507C47.2852 84.4654 38.1499 74.6247 38.1499 62.5974C38.1499 47.3981 49.6943 34.9619 63.8049 34.9619H82.2853C96.3953 34.9619 107.94 47.3981 107.94 62.5974C107.94 74.6247 98.8047 84.4654 87.6386 84.4654Z"
      fill="url(#paint10_linear_2705_52702)"
    />
    <path
      d="M87.836 84.4078H58.2527C47.8438 84.4078 39.3267 75.233 39.3267 64.0199V63.0617C39.3267 48.8916 50.0896 37.2979 63.2443 37.2979H82.8445C95.9997 37.2979 106.761 48.8916 106.761 63.0617V64.0199C106.762 75.2327 98.2462 84.4078 87.836 84.4078Z"
      fill="white"
    />
    <path
      d="M89.8626 72.3233C91.0238 72.3233 91.9746 71.8318 91.9746 71.2304C93.8261 65.4248 93.7829 59.4535 91.9746 53.3275C91.9746 52.7262 91.0238 52.2344 89.8626 52.2344C88.7021 52.2344 87.752 52.7262 87.752 53.3275V71.2304C87.752 71.8318 88.7021 72.3233 89.8626 72.3233Z"
      fill="url(#paint11_radial_2705_52702)"
    />
    <path
      d="M57.4546 72.3233C56.2947 72.3233 55.3439 71.8321 55.3439 71.2301C53.493 65.4238 53.5356 59.4535 55.3439 53.3282C55.3439 52.7259 56.2947 52.2344 57.4546 52.2344C58.6164 52.2344 59.5665 52.7259 59.5665 53.3282V71.2301C59.5665 71.8321 58.6164 72.3233 57.4546 72.3233Z"
      fill="url(#paint12_radial_2705_52702)"
    />
    <g filter="url(#filter0_d_2705_52702)">
      <path
        d="M61.0049 89.182L61.1096 78.8496C61.1162 78.1938 61.8413 77.8565 62.3357 78.2793L69.6921 84.5703C70.1794 84.9871 70.0265 85.7927 69.4372 85.9727C66.6995 86.8088 64.7949 87.8487 62.2661 89.8567C61.7584 90.2598 60.9981 89.8585 61.0049 89.182Z"
        fill="url(#paint13_linear_2705_52702)"
      />
      <path
        d="M82.5032 79.4853L74.6756 84.253C73.9943 84.6681 74.2055 85.9976 74.9424 86.1465C77.8268 86.7293 79.5767 88.3564 82.43 90.7922C82.899 91.1925 83.5694 90.7592 83.5664 90.0598L83.5229 80.1981C83.5201 79.5778 82.9759 79.1974 82.5032 79.4853Z"
        fill="url(#paint14_linear_2705_52702)"
      />
      <ellipse
        rx="2.23664"
        ry="2.11589"
        transform="matrix(0.792099 -0.583864 0.577651 0.797773 71.6428 86.3479)"
        fill="#35B5DF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2705_52702"
        x="59.4342"
        y="78.0918"
        width="25.703"
        height="15.995"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.57073" />
        <feGaussianBlur stdDeviation="0.785366" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2705_52702" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2705_52702"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2705_52702"
        x1="47.3314"
        y1="8.48304"
        x2="98.758"
        y2="8.48304"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.014" stop-color="#00B0ED" />
        <stop offset="0.1059" stop-color="#77CEF3" />
        <stop offset="0.2637" stop-color="#77CEF3" />
        <stop offset="0.9391" stop-color="#77CEF3" />
        <stop offset="1" stop-color="#00B0ED" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(73.0468 12.6031) scale(16.348 17.6104)"
      >
        <stop stop-color="#63C9F3" />
        <stop offset="0.5787" stop-color="#00B0ED" />
        <stop offset="0.8316" stop-color="#00AFEB" />
        <stop offset="0.9226" stop-color="#00ABE5" />
        <stop offset="0.9874" stop-color="#00A5DC" />
        <stop offset="1" stop-color="#009BCC" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(71.9811 42.0053) scale(54.4823 69.0364)"
      >
        <stop stop-color="#63C9F3" />
        <stop offset="0.4961" stop-color="#00B0ED" />
        <stop offset="0.7732" stop-color="#00AFEB" />
        <stop offset="0.873" stop-color="#00ABE3" />
        <stop offset="0.9439" stop-color="#00A4D9" />
        <stop offset="1" stop-color="#009BCC" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(118.429 85.1844) rotate(170.451) scale(20.0826 9.81487)"
      >
        <stop stop-color="white" />
        <stop offset="0.1486" stop-color="#F9FDFF" />
        <stop offset="0.2832" stop-color="#EDF7FD" />
        <stop offset="0.4125" stop-color="#D9F0FC" />
        <stop offset="0.5386" stop-color="#BEE5FA" />
        <stop offset="0.6623" stop-color="#99D8F7" />
        <stop offset="0.7842" stop-color="#67CAF3" />
        <stop offset="0.9023" stop-color="#00BCF0" />
        <stop offset="1" stop-color="#00B0ED" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(123.97 76.0052) rotate(170.451) scale(23.3314 11.4027)"
      >
        <stop stop-color="white" />
        <stop offset="0.1486" stop-color="#F9FDFF" />
        <stop offset="0.2832" stop-color="#EDF7FD" />
        <stop offset="0.4125" stop-color="#D9F0FC" />
        <stop offset="0.5386" stop-color="#BEE5FA" />
        <stop offset="0.6623" stop-color="#99D8F7" />
        <stop offset="0.7842" stop-color="#67CAF3" />
        <stop offset="0.9023" stop-color="#00BCF0" />
        <stop offset="1" stop-color="#00B0ED" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(128.599 67.336) rotate(164.849) scale(29.1357 14.1581)"
      >
        <stop stop-color="white" />
        <stop offset="0.1486" stop-color="#F9FDFF" />
        <stop offset="0.2832" stop-color="#EDF7FD" />
        <stop offset="0.4125" stop-color="#D9F0FC" />
        <stop offset="0.5386" stop-color="#BEE5FA" />
        <stop offset="0.6623" stop-color="#99D8F7" />
        <stop offset="0.7842" stop-color="#67CAF3" />
        <stop offset="0.9023" stop-color="#00BCF0" />
        <stop offset="1" stop-color="#00B0ED" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.6802 83.5256) rotate(9.54871) scale(20.0829 9.81503)"
      >
        <stop stop-color="white" />
        <stop offset="0.1486" stop-color="#F9FDFF" />
        <stop offset="0.2832" stop-color="#EDF7FD" />
        <stop offset="0.4125" stop-color="#D9F0FC" />
        <stop offset="0.5386" stop-color="#BEE5FA" />
        <stop offset="0.6623" stop-color="#99D8F7" />
        <stop offset="0.7842" stop-color="#67CAF3" />
        <stop offset="0.9023" stop-color="#00BCF0" />
        <stop offset="1" stop-color="#00B0ED" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.1387 74.3467) rotate(9.54871) scale(23.3314 11.4027)"
      >
        <stop stop-color="white" />
        <stop offset="0.1486" stop-color="#F9FDFF" />
        <stop offset="0.2832" stop-color="#EDF7FD" />
        <stop offset="0.4125" stop-color="#D9F0FC" />
        <stop offset="0.5386" stop-color="#BEE5FA" />
        <stop offset="0.6623" stop-color="#99D8F7" />
        <stop offset="0.7842" stop-color="#67CAF3" />
        <stop offset="0.9023" stop-color="#00BCF0" />
        <stop offset="1" stop-color="#00B0ED" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.5098 65.6766) rotate(15.1511) scale(29.1355 14.158)"
      >
        <stop stop-color="white" />
        <stop offset="0.1486" stop-color="#F9FDFF" />
        <stop offset="0.2832" stop-color="#EDF7FD" />
        <stop offset="0.4125" stop-color="#D9F0FC" />
        <stop offset="0.5386" stop-color="#BEE5FA" />
        <stop offset="0.6623" stop-color="#99D8F7" />
        <stop offset="0.7842" stop-color="#67CAF3" />
        <stop offset="0.9023" stop-color="#00BCF0" />
        <stop offset="1" stop-color="#00B0ED" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(73.0448 59.7144) scale(32.3087 34.8035)"
      >
        <stop stop-color="#63C9F3" />
        <stop offset="0.4961" stop-color="#00B0ED" />
        <stop offset="0.7732" stop-color="#00AFEB" />
        <stop offset="0.873" stop-color="#00ABE3" />
        <stop offset="0.9439" stop-color="#00A4D9" />
        <stop offset="1" stop-color="#009BCC" />
      </radialGradient>
      <linearGradient
        id="paint10_linear_2705_52702"
        x1="73.7048"
        y1="34.9464"
        x2="72.9411"
        y2="62.4856"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.4e-07" stop-color="#DDDFE3" />
        <stop offset="0.2271" stop-color="#E8E9EB" />
        <stop offset="0.5942" stop-color="#F4F4F5" />
        <stop offset="1" stop-color="#F9F9F9" />
      </linearGradient>
      <radialGradient
        id="paint11_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(90.5496 62.2789) scale(6.88358 7.41515)"
      >
        <stop stop-color="#00B0ED" />
        <stop offset="0.0849" stop-color="#00ABE5" />
        <stop offset="0.2237" stop-color="#00A3D4" />
        <stop offset="0.3991" stop-color="#2995B9" />
        <stop offset="0.6042" stop-color="#4B7C92" />
        <stop offset="0.8315" stop-color="#47565F" />
        <stop offset="1" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_2705_52702"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(56.7689 62.2789) scale(6.88357 7.41515)"
      >
        <stop stop-color="#00B0ED" />
        <stop offset="0.0849" stop-color="#00ABE5" />
        <stop offset="0.2237" stop-color="#00A3D4" />
        <stop offset="0.3991" stop-color="#2995B9" />
        <stop offset="0.6042" stop-color="#4B7C92" />
        <stop offset="0.8315" stop-color="#47565F" />
        <stop offset="1" />
      </radialGradient>
      <linearGradient
        id="paint13_linear_2705_52702"
        x1="60.1963"
        y1="84.6108"
        x2="70.922"
        y2="86.5957"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15625" stop-color="#1F7D9C" />
        <stop offset="0.553486" stop-color="#7ADDFF" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2705_52702"
        x1="89.7369"
        y1="84.4847"
        x2="73.5492"
        y2="89.1433"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.3125" stop-color="#1F7D9C" />
        <stop offset="1" stop-color="#7ADDFF" />
      </linearGradient>
    </defs>
  </svg>
);


export const HyBlastApproverNotificationIcon = ({ stroke = "#333333", fill = "none" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 5.5H17.5C17.7652 5.5 18.0196 5.60536 18.2071 5.79289C18.3946 5.98043 18.5 6.23478 18.5 6.5V18.5C18.5 18.7652 18.3946 19.0196 18.2071 19.2071C18.0196 19.3946 17.7652 19.5 17.5 19.5H6.5C6.23478 19.5 5.98043 19.3946 5.79289 19.2071C5.60536 19.0196 5.5 18.7652 5.5 18.5V6.5C5.5 6.23478 5.60536 5.98043 5.79289 5.79289C5.98043 5.60536 6.23478 5.5 6.5 5.5H7.5"
      stroke={stroke}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 4.5H9.5V6.5H14.5V4.5Z"
      stroke={stroke}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M9 13L11 15L15 11" stroke={stroke} stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const AttachIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.75">
      <path
        d="M10.5887 8.18273L8.52277 10.2487C8.0532 10.7182 8.0532 11.48 8.52277 11.9502C8.99233 12.4198 9.75408 12.4198 10.2243 11.9502L13.0197 9.15486C13.9595 8.21505 13.9595 6.69155 13.0197 5.75173C12.0799 4.81192 10.5564 4.81192 9.61658 5.75173L6.57852 8.79048C5.16914 10.1999 5.16914 12.4851 6.57852 13.8952C7.98789 15.3045 10.2731 15.3045 11.6832 13.8952L14.4779 11.0998"
        stroke="#333333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const BinIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M6.94727 10.6221V17.0533C6.94727 18.0685 7.76955 18.8908 8.78477 18.8908H16.1348C17.15 18.8908 17.9723 18.0685 17.9723 17.0533V10.6221"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.02832 7.86523H18.8908"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6221 7.86563V5.10938H14.2971V7.86563"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4595 11.541V16.1348"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2158 11.541V16.1348"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.70312 11.541V16.1348"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
export const BackArrowIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M23.5 16H9.4375" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14.125 11.3125L9.4375 16L14.125 20.6875"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const ReportIcon2 = (props) => (
  <SvgIcon {...props}>
    <path d="M11.8749 24.708V12.7913" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M16.4581 24.708V17.3747" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M21.0415 24.708V12.7913" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M25.6249 24.708V17.3747" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M7.2915 24.708V8.20801" strokeMiterlimit="10" strokeLinecap="square" />
  </SvgIcon>
);

export const IconDownArrowSM = ({ stroke = "#333333", fill = "none" }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6.40039L8 10.4004L4 6.40039"
        stroke={stroke}
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  );
};

export const IconLeftArrowLG = ({ stroke = "#333333", fill = "none" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3984 6L8.39844 12L14.3984 18"
        stroke={stroke}
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  );
};

export const IconUpArrow = ({
  stroke = "#333333",
  fill = "none",
  height = "20",
  width = "20",
  viewBox = "0 0 20 20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 8L10 13L5 8" stroke={stroke} strokeMiterlimit="10" stroke-linecap="square" />
    </svg>
  );
};

export const UnAuthIconAppSwitcher = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1111 7.11121H4.88889C4.39797 7.11121 4 7.50918 4 8.00009V11.5557C4 12.0466 4.39797 12.4445 4.88889 12.4445H11.1111C11.602 12.4445 12 12.0466 12 11.5557V8.00009C12 7.50918 11.602 7.11121 11.1111 7.11121Z"
      stroke="#999999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99997 10.6672C8.49089 10.6672 8.88886 10.2692 8.88886 9.77829C8.88886 9.28737 8.49089 8.8894 7.99997 8.8894C7.50905 8.8894 7.11108 9.28737 7.11108 9.77829C7.11108 10.2692 7.50905 10.6672 7.99997 10.6672Z"
      stroke="#999999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.222 6.99992V5.55558C10.2278 4.97213 10.0017 4.41026 9.59328 3.99354C9.18489 3.57681 8.6277 3.33934 8.04425 3.33336H7.99981C7.41636 3.32756 6.85449 3.55372 6.43776 3.96211C6.02103 4.3705 5.78357 4.92769 5.77759 5.51114V6.99992"
      stroke="#999999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DiamondIconAppSwitcher = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.33333 3.66663H11.6667L13 6.33329L8 12.3333L3 6.33329L4.33333 3.66663Z"
      stroke="#26BBED"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 6.33325H11"
      stroke="#26BBED"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HyMailAILarge = () => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" fill="#26BBED" />
    <path
      d="M13.6777 28.691H13.357C12.8987 28.691 12.6696 28.4358 12.6696 27.9253V19.0071C12.6696 17.6258 12.0738 16.9352 10.8823 16.9352H9.23255C7.91885 16.9352 7.262 17.5958 7.262 18.917V27.9253C7.262 28.4358 7.03286 28.691 6.57459 28.691H6.25381C6.0094 28.691 5.82609 28.6009 5.70389 28.4208C5.61223 28.2406 5.56641 28.0754 5.56641 27.9253V11.2149C5.56641 11.0348 5.61223 10.8696 5.70389 10.7195C5.82609 10.5393 6.0094 10.4492 6.25381 10.4492H6.57459C7.03286 10.4492 7.262 10.7045 7.262 11.2149V15.5839C7.96467 15.2837 8.62152 15.1335 9.23255 15.1335H10.8823C11.9516 15.1335 12.807 15.4788 13.4486 16.1695C14.0902 16.8301 14.411 17.776 14.411 19.0071V27.9253C14.411 28.4358 14.1666 28.691 13.6777 28.691Z"
      fill="white"
    />
    <path
      d="M22.9688 27.7001C22.7244 28.4208 22.5105 29.0213 22.3272 29.5018C22.1439 29.9822 21.9758 30.3425 21.8231 30.5827C21.0288 31.8739 19.9595 32.5195 18.6152 32.5195H18.0195C17.8362 32.5195 17.6529 32.4595 17.4695 32.3394C17.2862 32.2493 17.1946 32.0541 17.1946 31.7538V31.4836C17.1946 31.2434 17.271 31.0482 17.4237 30.898C17.5765 30.7779 17.7751 30.7179 18.0195 30.7179H18.6152C19.3179 30.7179 19.8373 30.4476 20.1733 29.9071C20.5094 29.3666 20.7843 28.7811 20.9982 28.1505C20.3872 26.4389 19.7151 24.5472 18.9818 22.4753C18.2486 20.4034 17.5459 18.3765 16.8738 16.3947C16.8127 16.2446 16.8127 16.0494 16.8738 15.8092C16.9655 15.5689 17.164 15.4488 17.4695 15.4488H17.8362C18.1111 15.4488 18.325 15.5839 18.4777 15.8542C18.5388 15.9743 18.5694 16.0344 18.5694 16.0344L21.8231 25.5831L23.9311 19.4125L25.0768 16.0344C25.2295 15.644 25.4892 15.4488 25.8558 15.4488H26.1766C26.5127 15.4488 26.7113 15.5839 26.7724 15.8542C26.8335 16.0944 26.8488 16.2896 26.8182 16.4397L22.9688 27.7001Z"
      fill="white"
    />
    <path
      d="M30.2488 28.691H29.928C29.6836 28.691 29.5003 28.6009 29.3781 28.4208C29.2864 28.2406 29.2406 28.0754 29.2406 27.9253V11.2149C29.2406 11.0348 29.2864 10.8696 29.3781 10.7195C29.5003 10.5393 29.6836 10.4492 29.928 10.4492H30.2488C30.7376 10.4492 30.982 10.7045 30.982 11.2149V27.9253C30.982 28.4358 30.7376 28.691 30.2488 28.691Z"
      fill="white"
    />
    <path
      d="M39.8853 27.7001C39.6409 28.4208 39.427 29.0213 39.2437 29.5018C39.0604 29.9822 38.8924 30.3425 38.7396 30.5827C37.9453 31.8739 36.876 32.5195 35.5317 32.5195H34.936C34.7527 32.5195 34.5694 32.4595 34.3861 32.3394C34.2028 32.2493 34.1111 32.0541 34.1111 31.7538V31.4836C34.1111 31.2434 34.1875 31.0482 34.3402 30.898C34.493 30.7779 34.6916 30.7179 34.936 30.7179H35.5317C36.2344 30.7179 36.7538 30.4476 37.0898 29.9071C37.4259 29.3666 37.7009 28.7811 37.9147 28.1505C37.3037 26.4389 36.6316 24.5472 35.8984 22.4753C35.1651 20.4034 34.4624 18.3765 33.7903 16.3947C33.7292 16.2446 33.7292 16.0494 33.7903 15.8092C33.882 15.5689 34.0806 15.4488 34.3861 15.4488H34.7527C35.0276 15.4488 35.2415 15.5839 35.3943 15.8542C35.4554 15.9743 35.4859 16.0344 35.4859 16.0344L38.7396 25.5831L40.8476 19.4125L41.9933 16.0344C42.1461 15.644 42.4058 15.4488 42.7724 15.4488H43.0931C43.4292 15.4488 43.6278 15.5839 43.6889 15.8542C43.75 16.0944 43.7653 16.2896 43.7347 16.4397L39.8853 27.7001Z"
      fill="white"
    />
    <path
      d="M34.7773 41.5039C34.6875 41.5039 34.6201 41.459 34.5752 41.3691C34.5303 41.2643 34.5078 41.167 34.5078 41.0771V39.8418C34.5078 39.7519 34.5303 39.6621 34.5752 39.5723C34.6201 39.4674 34.6875 39.415 34.7773 39.415H35.2266C35.3164 39.415 35.3838 39.4674 35.4287 39.5723C35.4736 39.6621 35.4961 39.7519 35.4961 39.8418V41.0771C35.4961 41.167 35.4736 41.2643 35.4287 41.3691C35.3838 41.459 35.3164 41.5039 35.2266 41.5039H34.7773Z"
      fill="white"
    />
    <path
      d="M41.3647 41.5039C41.2605 41.5039 41.1824 41.4674 41.1303 41.3945C41.0782 41.3216 41.0418 41.2591 41.0209 41.207L40.5834 39.8789H38.5209L38.0522 41.2383C38.0314 41.3112 37.9897 41.3737 37.9272 41.4258C37.8647 41.4778 37.7918 41.5039 37.7085 41.5039H37.5991C37.4637 41.5039 37.3699 41.4518 37.3178 41.3476C37.2657 41.2435 37.2553 41.1497 37.2866 41.0664L39.0991 35.4727C39.1199 35.431 39.1512 35.3737 39.1928 35.3008C39.2449 35.2279 39.3282 35.1914 39.4428 35.1914H39.6459C39.823 35.1914 39.9428 35.2799 40.0053 35.457L41.8178 41.0664C41.8491 41.1497 41.8387 41.2435 41.7866 41.3476C41.7345 41.4518 41.6407 41.5039 41.5053 41.5039H41.3647ZM39.5366 36.6133C39.4845 36.8008 39.422 37.0091 39.3491 37.2383C39.2866 37.4674 39.2189 37.6914 39.1459 37.9101C39.0834 38.1289 39.0209 38.3372 38.9584 38.5351C38.8959 38.7331 38.8439 38.8997 38.8022 39.0351H40.3022L39.5366 36.6133Z"
      fill="white"
    />
    <path
      d="M43.1664 41.5039C43.0519 41.5039 42.9685 41.4622 42.9164 41.3789C42.8748 41.2956 42.8539 41.2174 42.8539 41.1445V35.5508C42.8539 35.4674 42.8748 35.3893 42.9164 35.3164C42.9685 35.2331 43.0519 35.1914 43.1664 35.1914H43.2914C43.5102 35.1914 43.6196 35.3112 43.6196 35.5508V41.1445C43.6196 41.3841 43.5102 41.5039 43.2914 41.5039H43.1664Z"
      fill="white"
    />
  </svg>
);

export const EditIcon = ({ stroke = "#333333", fill = "none" }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7656 5.59595L14.9602 8.79054" stroke={stroke} strokeMiterlimit="10" />
    <path
      d="M7.72218 16.0281L3.88867 16.667L4.52759 12.8335L13.098 4.26305C13.3377 4.02349 13.6626 3.88892 14.0015 3.88892C14.3403 3.88892 14.6653 4.02349 14.9049 4.26305L16.2926 5.65078C16.5322 5.89041 16.6668 6.21537 16.6668 6.55421C16.6668 6.89304 16.5322 7.21801 16.2926 7.45764L7.72218 16.0281Z"
      stroke={stroke}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);

export const ScheduleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.875 8.625H22.125" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.125 8.62501V5.92501C22.125 5.56697 21.9828 5.22359 21.7296 4.97042C21.4764 4.71724 21.133 4.57501 20.775 4.57501H3.225C2.86696 4.57501 2.52358 4.71724 2.27041 4.97042C2.01723 5.22359 1.875 5.56697 1.875 5.92501V20.775C1.875 21.1331 2.01723 21.4764 2.27041 21.7296C2.52358 21.9828 2.86696 22.125 3.225 22.125H9.975"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.27539 1.875V4.575" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.7246 1.875V4.575" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16.7252 22.125C19.7075 22.125 22.1252 19.7073 22.1252 16.725C22.1252 13.7427 19.7075 11.325 16.7252 11.325C13.7429 11.325 11.3252 13.7427 11.3252 16.725C11.3252 19.7073 13.7429 22.125 16.7252 22.125Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7246 14.025V16.725H19.4246"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.3125 8.5625L15.4375 1.6875V5.8125C11.098 5.8125 5.8125 8.36175 5.8125 15.4375C7.95613 11.9684 12 11.3125 15.4375 11.3125V15.4375L22.3125 8.5625Z"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.3125 15.4375V20.9375C22.3125 21.6965 21.6965 22.3125 20.9375 22.3125H3.0625C2.3035 22.3125 1.6875 21.6965 1.6875 20.9375V5.8125C1.6875 5.0535 2.3035 4.4375 3.0625 4.4375H5.8125"
      stroke="#333333"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StatisticsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 10.5L9.5 3.5L15.5 9.5L22.5 2.5"
      stroke="#212121"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path d="M3.5 22.5V19.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M9.5 12.5V22.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M15.5 22.5V19.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M21.5 12.5V22.5" stroke="#212121" strokeMiterlimit="10" strokeLinecap="square" />
  </svg>
);

export const SlidesPreviewIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.87267 13.683C1.6301 13.3362 1.5 12.9232 1.5 12.5C1.5 12.0768 1.6301 11.6638 1.87267 11.317C3.44567 9.09 7.31867 4.5 12.4997 4.5C17.6807 4.5 21.5537 9.09 23.1267 11.317C23.3692 11.6638 23.4993 12.0768 23.4993 12.5C23.4993 12.9232 23.3692 13.3362 23.1267 13.683C21.5537 15.91 17.6807 20.5 12.4997 20.5C7.31867 20.5 3.44567 15.91 1.87267 13.683Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 16.5C14.7091 16.5 16.5 14.7091 16.5 12.5C16.5 10.2909 14.7091 8.5 12.5 8.5C10.2909 8.5 8.5 10.2909 8.5 12.5C8.5 14.7091 10.2909 16.5 12.5 16.5Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);